import { render, staticRenderFns } from "./donutGauge.vue?vue&type=template&id=31c32f1a&scoped=true&"
import script from "./donutGauge.vue?vue&type=script&lang=js&"
export * from "./donutGauge.vue?vue&type=script&lang=js&"
import style0 from "./donutGauge.vue?vue&type=style&index=0&id=31c32f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c32f1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VRow})
